import { Alert, Badge, Box, Divider, FormControlLabel, Grid, Paper, Radio, RadioGroup, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import WSTextField, { TextType } from "../../../Components/TextBox/WSTextBox";
import WSButton from "../../../Components/Button/WSButton";

import { callAPI, clearRequest, Method } from "../../../commonFunctions/CommonFunctions";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import { useNavigate, useParams } from "react-router-dom";
import WSFileUpload from "../../../Components/FileUpload/WSFileUpload";
import { Header } from "../../../Components/Header/Header";
import WSHiddenField from "../../../Components/HiddenField/WSHiddenField";
import WSDateField from "../../../Components/DateField/WSDateField";
import dayjs from "dayjs";
import WSSelectField from "../../../Components/Select/WSSelect";
import clientConfig from '../../../Config/clientConfig.json'
// import WSRadioField from "../../../Components/Radio/WSRadio";
export const Promotion: React.FC<any> = React.memo(() => {
  const { control, register, handleSubmit, setValue, reset, watch } = useForm();
  const { showMessage } = useSnackbar();
  const params = useParams();
  const navigate = useNavigate();

  const id = params?.id;

  const [subitting, setSubmitting] = useState<boolean>(false);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [defaultImg, setDefaultImg] = useState<any | null>(null);
  const [startDate, setStartDate] = useState<string>()
  // Watch the offerType value from form instead of separate state
  const offerType = watch('offerType') || 'ALL';

  const offerTypeOptions = [
    { value: 'ALL', label: 'Apply to all categories' },
    { value: 'SPECIFIC', label: 'Apply to specific category' }
  ];


  useEffect(
    () => () => {
      reset();
    },
    []
  );
  useEffect(() => {
    /**
     * Edit Function
     * @param id
     *
     */
    async function getPromotionById(id: any) {
      try {
        const response: any = await callAPI(`offers/getBy`, Method.GET, {}, id);

        if (response && response?.data) {
          setValue("name", response.data.name);
          setValue("buttonLabel", response.data.buttonLabel);
          setDefaultImg(response.data?.imageUrl)
          setValue("startDate", dayjs(response.data?.startDate).format('DD/MM/YYYY'));
          setValue("endDate", dayjs(response.data?.endDate).format('DD/MM/YYYY'));
          setValue("offerType", response.data.category !== 'ALL' ? 'SPECIFIC' : 'ALL');
          setValue("category", response.data.category);
        }
      } catch (error) {
        console.error("failed to retrieve data", error);
      }
    }
    if (id) {
      getPromotionById(id);
    }
  }, [id, setValue]);

  /**
   * Method for Add/Update the data
   * @param data
   */
  const handleData = async (data: any) => {
    try {
      setSubmitting(true);
      // Extract image name from the uploaded file.
      let imageName = "";
      if (data.imageUrl && data.imageUrl[0]) {
        const file = data.imageUrl[0]; // Assuming `imageUrl` contains an array of files.
        imageName = file.name; // Get the file name from the uploaded image.
      }
      // const filePath = data.filePath || "";
      const startDate = dayjs(data.startDate, "DD/MM/YYYY").format('YYYY-MM-DDTHH:mm:ss.SSS')
      const endDate = dayjs(data.endDate, "DD/MM/YYYY").format('YYYY-MM-DDTHH:mm:ss.SSS')
      const formData = new FormData()
      formData.append("file", selectedFile!);
      formData.append("name", data.name); // Add title
      formData.append("buttonLabel", data.buttonLabel); // Add button text
      formData.append("startDate", startDate);
      formData.append("endDate", endDate);
      formData.append("category", offerType === 'ALL' ? offerType : data.category);

      // const newRequest = clearRequest(request)
      if (id) {
        const response: any = await callAPI(`offers/update/${id}`, Method.PUTFORMDATA, null, null, formData);
        if (response) {
          showMessage(response?.message, response.success === true ? "success" : "error");
          if (response?.success === true) {
            callNotificationAPI(data.notificationType, data.category)
            navigate('/promotion/list')
          }
        }

      } else {
        const response: any = await callAPI("offers/create", Method.POSTFORMDATA, null, null, formData);
        if (response) {
          showMessage(response?.message, response.success === true ? "success" : "error");
          if (response?.success === true) {
            callNotificationAPI(data.notificationType, data.category)
            navigate('/promotion/list')
          }
        }
      }
    } catch (e: any) {
      showMessage(e?.response?.data?.message || "something went wrong",'error');
    }
    finally{
      setSubmitting(false);
    }
  };
  
  const callNotificationAPI = async (type: string, categoryId?: string) => {
    let notificationResponse: any = {};
    switch (type) {
      case 'SA':
        notificationResponse = await callAPI('Notifications/sendAll', Method.POST, { title: 'Metrofresh', body: "You have an offer!" });
        break;
      case 'SC':
        notificationResponse = await callAPI('Notifications/sendCategory', Method.POST, { title: 'Metrofresh', body: "You have an offer!", category: categoryId },);
        break;
    }
    return notificationResponse;

  }
  const handleCancelClick = () => {
    navigate('/promotion/list')
  }
  const handleUploadFile = (file: any) => {
    setDefaultImg(null)
    if (file && file.length > 0) {
      setSelectedFile(file[0]);
    }
  }
  const handleRemove = (id: string) => {
    alert(id)
  }

  const handleStartDateChange = (evt: any) => {
    setStartDate(evt)
  }
  
  return (
    <>
      <Header
        type="simple"
        isDivider={true}
        title={`${id ? 'Edit' : 'Add'} Promotion`}
        url="/promotion/list"
        id={'promotionImg'}
        isBackButton={true}
        headerSx={{
          marginTop: 0,
        }}
      />

      <form onSubmit={handleSubmit(handleData)}>
        <Grid
          sx={{
            padding: 4,
            backgroundColor: "#fff",
            borderRadius: "0 0 12px 12px",
            border: "1px solid #e2e8f0",
            marginTop: 0,
            background: "linear-gradient(to bottom, #ffffff, #f8fafc)",
          }}
        >

          <Grid item xs={12}>
            <Box sx={{
              padding: 2,
              backgroundColor: "#f0f7ff",
              borderRadius: "8px",
              border: "1px solid #c2e0ff",
              marginBottom: 3
            }}>
              <Typography variant="h6" sx={{
                color: "#0056b3",
                fontWeight: 600,
                display: "flex",
                alignItems: "center",
                fontSize: "1.1rem",
                mb: 1
              }}>
                <Badge sx={{
                  background: "#0056b3",
                  color: "white",
                  borderRadius: "50%",
                  width: 24,
                  height: 24,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mr: 1.5,
                  fontSize: "0.75rem"
                }}>
                  1
                </Badge>
                Offer Type
              </Typography>

              <Alert severity="info" sx={{ mb: 2, borderRadius: '8px' }}>
                Select whether this offer applies to all categories or a specific one.
              </Alert>

              <Controller
                name="offerType"
                control={control}
                defaultValue="ALL"
                rules={{ required: true }}
                render={({ field }) => (
                  <RadioGroup
                    {...field}
                    value={field.value || 'ALL'}
                    onChange={(e) => {
                      const value = e.target.value as 'ALL' | 'SPECIFIC';
                      field.onChange(e);
                      if (value === 'ALL') {
                        setValue('category', '');
                      }
                    }}
                  >
                    <Grid container spacing={2}>
                      {offerTypeOptions.map(option => (
                        <Grid item xs={12} sm={6} key={option.value}>
                          <Paper
                            elevation={field.value === option.value ? 3 : 0}
                            sx={{
                              p: 2,
                              borderRadius: '8px',
                              border: `2px solid ${field.value === option.value ? '#1976d2' : '#e2e8f0'}`,
                              backgroundColor: field.value === option.value ? '#f0f7ff' : '#f8fafc',
                              cursor: 'pointer',
                              '&:hover': {
                                borderColor: '#1976d2',
                                backgroundColor: '#f0f7ff'
                              }
                            }}
                            onClick={() => {
                              setValue('offerType', option.value);
                              if (option.value === 'ALL') {
                                setValue('category', '');
                              }
                            }}
                          >
                            <FormControlLabel
                              value={option.value}
                              control={<Radio />}
                              label={option.label}
                              sx={{ width: '100%', m: 0 }}
                            />
                          </Paper>
                        </Grid>
                      ))}
                    </Grid>
                  </RadioGroup>
                )}
              />
            </Box>
          </Grid>


          <Grid item container spacing={3}>
            {/* Basic Information Section */}
            <Grid item xs={12}>
              <Box sx={{
                padding: 2,
                backgroundColor: "#f8fafc",
                borderRadius: "8px",
                border: "1px solid #e2e8f0",
                marginBottom: 2
              }}>
                <Typography variant="h6" sx={{
                  color: "#334155",
                  fontWeight: 600,
                  display: "flex",
                  alignItems: "center",
                  fontSize: "1.1rem"
                }}>
                  <Badge sx={{
                    background: "#667eea",
                    color: "white",
                    borderRadius: "50%",
                    width: 24,
                    height: 24,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mr: 1.5,
                    fontSize: "0.75rem"
                  }}>
                    1
                  </Badge>
                  Basic Information
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12} sm={6}>
              <WSTextField
                label={"Name"}
                {...register("name")}
                id="name"
                name="name"
                control={control}
                rules={{ required: true }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "8px",
                    "&:hover fieldset": {
                      borderColor: "#667eea",
                    },
                  }
                }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <WSTextField
                label={"Button Label"}
                {...register("buttonLabel")}
                id="buttonLabel"
                name="buttonLabel"
                control={control}
                rules={{ required: false }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "8px",
                    "&:hover fieldset": {
                      borderColor: "#667eea",
                    },
                  }
                }}
              />
            </Grid>

            {offerType === 'SPECIFIC' && <Grid item xs={12} sm={6}>
              <WSSelectField
                label={"Category"}
                {...register("category")}
                id="category"
                name="category"
                control={control}
                options={clientConfig.promotionCatConfig.staticOptionData}
                rules={{ required: true }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "8px",
                    "&:hover fieldset": {
                      borderColor: "#667eea",
                    },
                  }
                }}
              />
            </Grid>}

            {/* Date Information Section */}
            <Grid item xs={12}>
              <Box sx={{
                padding: 2,
                backgroundColor: "#f8fafc",
                borderRadius: "8px",
                border: "1px solid #e2e8f0",
                margin: "20px 0 16px 0"
              }}>
                <Typography variant="h6" sx={{
                  color: "#334155",
                  fontWeight: 600,
                  display: "flex",
                  alignItems: "center",
                  fontSize: "1.1rem"
                }}>
                  <Badge sx={{
                    background: "#667eea",
                    color: "white",
                    borderRadius: "50%",
                    width: 24,
                    height: 24,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mr: 1.5,
                    fontSize: "0.75rem"
                  }}>
                    2
                  </Badge>
                  Date Information
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12} sm={6}>
              <WSDateField
                id="startDate"
                name="startDate"
                label={"Start Date"}
                dateFormat="DD-MM-YYYY"
                denyFuturOrPast="past"
                onChange={handleStartDateChange}
                control={control}
                defaultValue={null}
                rules={{ required: true }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "8px",
                    "&:hover fieldset": {
                      borderColor: "#667eea",
                    },
                  }
                }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <WSDateField
                id="endDate"
                name="endDate"
                label={"End Date"}
                dateFormat="DD-MM-YYYY"
                denyFuturOrPast="custom"
                control={control}
                defaultValue={startDate}
                setValue={setValue}
                rules={{ required: true }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "8px",
                    "&:hover fieldset": {
                      borderColor: "#667eea",
                    },
                  }
                }}
              />
            </Grid>

            {/* Image Upload Section */}
            <Grid item xs={12}>
              <Box sx={{
                padding: 2,
                backgroundColor: "#f8fafc",
                borderRadius: "8px",
                border: "1px solid #e2e8f0",
                margin: "20px 0 16px 0"
              }}>
                <Typography variant="h6" sx={{
                  color: "#334155",
                  fontWeight: 600,
                  display: "flex",
                  alignItems: "center",
                  fontSize: "1.1rem"
                }}>
                  <Badge sx={{
                    background: "#667eea",
                    color: "white",
                    borderRadius: "50%",
                    width: 24,
                    height: 24,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mr: 1.5,
                    fontSize: "0.75rem"
                  }}>
                    4
                  </Badge>
                  Promotion Image
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <WSFileUpload
                name="imageUrl"
                label="Upload Promotion Image"
                control={control}
                rules={{ required: defaultImg ? false : true }}
                acceptFileTypes=".jpg,.jpeg,.png"
                maxFileSizeMB={2}
                defaultValue={defaultImg}
                id={"imageUrl"}
                image={true}
                onChange={handleUploadFile}
                onRemove={handleRemove}
                isToolTipImg={false}
                multiple={false}
              />
            </Grid>

            <Grid item xs={12} sm={6} style={{ display: "none" }}>
              <WSHiddenField
                name="id"
                control={control}
              />
            </Grid>

            {/* Action Buttons */}
            <Grid
              item
              xs={12}
              sx={{
                marginTop: "2.5rem",
                paddingTop: "1.5rem",
                borderTop: "1px solid #e2e8f0",
                display: "flex",
                justifyContent: "flex-end",
                gap: 2,
              }}
            >
              <WSButton
                id="cancel"
                label={"Cancel"}
                type="button"
                onClick={handleCancelClick}
                size="small"
                className="ws-cancel"
                loading={subitting}
              />
              <WSButton
                id="submit"
                label={"Save Promotion"}
                type="submit"
                loading={subitting}
                size="small"
              />
            </Grid>
          </Grid>
        </Grid>
      </form>
    </>
  );
});
